export default __webpack_public_path__ + "static/media/quote_bg_3.a37fbc37.svg";